var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"dropdown-item notify-item",attrs:{"href":"#"},on:{"click":_vm.logOut}},[_c('i',{staticClass:"mdi mdi-logout"}),_vm._v(" "),_c('span',[_vm._v("Logout ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }